import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Classes from './PricingAndFaqs.module.css';
import './pricing.css';
import { motion, AnimatePresence } from 'framer-motion';

import {
  Button,
  ListItem,
  ListItemIcon,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { AnimateTopToBottom } from './Animations/AnimateTopToBottom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const TickBlue = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
)

const SectionE = () => {
  const sectionRef = useRef(null); // Reference to the section
  const [isYearly, setisYearly] = useState(true);
  const [expanded, setExpanded] = useState('');
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const navigate = useNavigate();

  const navigateToSignup = () => {
    navigate('/login', { state: { data: "toSignup" } });
  }

  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  const { user } = useSelector((state) => state.auth);

  const faqs = [
    {
      question: "What is Achorize?",
      answer: "Achorize is a client onboarding and management platform built for agencies and service-based businesses. It simplifies onboarding, automates workflows, and streamlines client management to help agencies scale effortlessly."
    },
    {
      question: "How does Achorize help agencies manage clients?",
      answer: "Anchorize helps agencies streamline client management by centralizing all information, orders, forms, and tickets in one platform. Its customizable workspaces enable seamless tracking of clients and projects."
    },
    {
      question: "Does Achorize integrate with third-party tools?",
      answer: "Yes, Anchorize integrates with payment processors like Stripe and PayPal, as well as email services like Gmail. We’re continually expanding our integrations to enhance functionality."
    },
    {
      question: "Can I customize the client portal to match my brand?",
      answer: "Both the agency and client dashboards are fully customizable and white-labeled, allowing you to match your brand’s color scheme, add your logo, and even get a unique landing page link."
    },
    {
      question: "What pricing plans does Achorize offer?",
      answer: (
        <>
          Anchorize offers three pricing plans. You can create an account for free and try any plan for 14 days.
        </>
      )
    }
  ];

  useEffect(() => {
    // Effect will trigger when `isYearly` changes
  }, [isYearly]);

  return (
    <section id='pricing' ref={sectionRef} className={Classes.section}>
      <div className={Classes.card}>
        <h1 className={Classes.subheading}> Plans for all agency sizes </h1>
        <div className={Classes.flex} >
          <div className={Classes.pricingBtns} >
            <button onClick={() => setisYearly(false)} className={!isYearly ? Classes.activeButton : Classes.inactiveButton}>
              <h5>Monthly</h5>
            </button>
            <button onClick={() => setisYearly(true)} className={isYearly ? Classes.activeButton : Classes.inactiveButton}>
              <h5>Yearly</h5>
            </button>
          </div>
          <h5 className={Classes.saveText} >Save 15% by billing annually</h5>
        </div>

        {isYearly ?
          <div className={Classes.boxesList} >
            <AnimatePresence>
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{
                  delay: 0,
                  duration: 0.3,
                }}
              >
                <div className={Classes.boxWhite} >
                  <h5 className={Classes.boxMiniTitle} >Basic</h5>
                  <h5 className={Classes.priceText} > $25 <span>/month</span> </h5>
                  <div className={Classes.list} >
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >2 team seats</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >White-labeled dashboard</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Unique landing page</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Custom onboarding</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} > Workflow management </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Client management </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Analytics </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Reporting </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >API integrations </h5>
                    </div>
                  </div>
                  <motion.div
                    whileTap={{ scale: 0.97 }}
                    whileHover={{ scale: 1.03 }} className={Classes.blueBtn} onClick={navigateToSignup} >
                    <h4>Get started for free</h4>
                  </motion.div>
                  <h5 className={`${Classes.text} ${Classes.center}`} >No credit card required</h5>
                </div>
              </motion.div>
            </AnimatePresence>
            <AnimatePresence>
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{
                  delay: 0.1,
                  duration: 0.3,
                }}
              >
                <div className={Classes.boxBlue} >
                  <h5 className={Classes.boxMiniTitle} >Pro</h5>
                  <h5 className={Classes.priceText} > {isYearly ? '$50' : '$100'} <span>/month</span> </h5>
                  <div className={Classes.list} >
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} >7 team seats</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} >White-labeled dashboard</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} >Unique landing page</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} >Custom onboarding</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} > Workflow management </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} >Client management </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} >Analytics </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} >Reporting </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.whiteTick} >
                        <TickBlue height='12px' fill='#0981fb' />
                      </div>
                      <h5 className={Classes.text} >API integrations </h5>
                    </div>
                  </div>
                  <motion.div
                    whileTap={{ scale: 0.97 }}
                    whileHover={{ scale: 1.03 }} className={Classes.whiteBtn} onClick={navigateToSignup} >
                    <h4>Get started for free</h4>
                  </motion.div>
                  <h5 className={`${Classes.text} ${Classes.center}`} >No credit card required</h5>
                </div>
              </motion.div>
            </AnimatePresence>
            <AnimatePresence>
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{
                  delay: 0.2,
                  duration: 0.3,
                }}
              >
                <div className={Classes.boxWhite} >
                  <h5 className={Classes.boxMiniTitle} >Enterprise</h5>
                  <h5 className={Classes.priceText} > $100 <span>/month</span> </h5>
                  <div className={Classes.list} >
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Unlimited team seats</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >White-labeled dashboard</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Unique landing page</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Custom onboarding</h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} > Workflow management </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Client management </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Analytics </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >Reporting </h5>
                    </div>
                    <div className={Classes.listItem} >
                      <div className={Classes.blueTick} >
                        <TickBlue height='12px' fill='white' />
                      </div>
                      <h5 className={Classes.text} >API integrations </h5>
                    </div>
                  </div>
                  <motion.div
                    whileTap={{ scale: 0.97 }}
                    whileHover={{ scale: 1.03 }}
                    className={Classes.blueBtn} onClick={navigateToSignup} >
                    <h4>Get started for free</h4>
                  </motion.div>
                  <h5 className={`${Classes.text} ${Classes.center}`} >No credit card required</h5>
                </div>
              </motion.div>
            </AnimatePresence>
          </div >
          :
          <div className={Classes.boxesList} >
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                delay: 0,
                duration: 0.3,
              }}
            >
              <div className={Classes.boxWhite} >
                <h5 className={Classes.boxMiniTitle} >Basic</h5>
                <h5 className={Classes.priceText} > $25 <span>/month</span> </h5>
                <div className={Classes.list} >
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >2 team seats</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >White-labeled dashboard</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Unique landing page</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Custom onboarding</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} > Workflow management </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Client management </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Analytics </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Reporting </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >API integrations </h5>
                  </div>
                </div>
                <motion.div
                  whileTap={{ scale: 0.97 }}
                  whileHover={{ scale: 1.03 }}
                  className={Classes.blueBtn} onClick={navigateToSignup} >
                  <h4>Get started for free</h4>
                </motion.div>
                <h5 className={`${Classes.text} ${Classes.center}`} >No credit card required</h5>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                delay: 0.1,
                duration: 0.3,
              }}
            >
              <div className={Classes.boxBlue} >
                <h5 className={Classes.boxMiniTitle} >Pro</h5>
                <h5 className={Classes.priceText} > {isYearly ? '$99' : '$114'} <span>/month</span> </h5>
                <div className={Classes.list} >
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} >7 team seats</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} >White-labeled dashboard</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} >Unique landing page</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} >Custom onboarding</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} > Workflow management </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} >Client management </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} >Analytics </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} >Reporting </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.whiteTick} >
                      <TickBlue height='12px' fill='#0981fb' />
                    </div>
                    <h5 className={Classes.text} >API integrations </h5>
                  </div>
                </div>
                <motion.div
                  whileTap={{ scale: 0.97 }}
                  whileHover={{ scale: 1.03 }}
                  className={Classes.whiteBtn} onClick={navigateToSignup} >
                  <h4>Get started for free</h4>
                </motion.div>
                <h5 className={`${Classes.text} ${Classes.center}`} >No credit card required</h5>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{
                delay: 0.2,
                duration: 0.3,
              }}
            >
              <div className={Classes.boxWhite} >
                <h5 className={Classes.boxMiniTitle} >Enterprise</h5>
                <h5 className={Classes.priceText} > $228 <span>/month</span> </h5>
                <div className={Classes.list} >
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Unlimited team seats</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >White-labeled dashboard</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Unique landing page</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Custom onboarding</h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} > Workflow management </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Client management </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Analytics </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >Reporting </h5>
                  </div>
                  <div className={Classes.listItem} >
                    <div className={Classes.blueTick} >
                      <TickBlue height='12px' fill='white' />
                    </div>
                    <h5 className={Classes.text} >API integrations </h5>
                  </div>
                </div>
                <motion.div
                  whileTap={{ scale: 0.97 }}
                  whileHover={{ scale: 1.03 }}
                  className={Classes.blueBtn} onClick={navigateToSignup} >
                  <h4>Get started for free</h4>
                </motion.div>
                <h5 className={`${Classes.text} ${Classes.center}`} >No credit card required</h5>
              </div>
            </motion.div>
          </div>
        }

        <div id='questions' className={Classes.faqs}>
          <h1 className={Classes.subheading}> FAQs </h1>
          <div className={Classes.faqsCon}>
            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                expanded={expanded === `panel${index + 1}`}
                onChange={handleChange(`panel${index + 1}`)}
                sx={{
                  border: '1px solid #80808024',
                  boxShadow: 'rgb(0 0 0 / 13%) 0px 1px 2px',
                  marginBottom: '1rem',
                  borderRadius: '7px !important',
                  padding: '6px 20px !important',
                  '&:before': {
                    display: 'none',
                  }
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`panel${index + 1}bh-content`}
                  id={`panel${index + 1}bh-header`}
                  sx={{
                    minHeight: '32px !important',
                    margin: '0 !important',
                    padding: '0px 10px !important',
                    '&.Mui-expanded': {
                      margin: '0 !important',
                      minHeight: '32px !important',
                      padding: '0px 10px !important',
                    },
                    '.MuiAccordionSummary-content': {
                      margin: '10px 0 !important'
                    },
                    '.MuiAccordionDetails-root': {
                      padding: '8px 12px 16px !important'
                    },
                  }}
                >
                  <div className={Classes.AccordionHeader}>
                    <h5>{faq.question}</h5>
                  </div>
                </AccordionSummary>
                <AccordionDetails className={Classes.accordinBody}
                  sx={{
                    padding: '8px 16px 16px 10px !important',
                  }}
                >
                  <h5 className={Classes.accordionText}>{faq.answer}</h5>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
        </div>
      </div >
    </section >
  );
};

export default SectionE;
